// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {
    ListItemIcon, ListItemText,
    Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {deleteDataPointXref, getDataPointXrefByDataPointId} from "../../DataPointXref/DataPointXrefClient";
import {changeDataPoint} from "../dataPointSlice";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import Typography from "@mui/material/Typography";


// Main Function
export default function DataPointXrefListDrawer({fetchDataPointXrefs}) {


    // ****************** BEGIN STATES ****************************

    const [dataPointXrefs, setDataPointXrefs] = useState([]);

    // ****************** END STATES ****************************

    const dispatchData = useDispatch();
    const hideActions = useSelector((state) => state.userProfileSlc.value.rights) !== "Super User";
    const [deleteOpen, setDeleteOpen] = React.useState(false);

    // ****************** BEGIN STORE ****************************

    const selectorDataPointId = useSelector((state) => state.dataPointSlc.value.dpxListId);
    const selectorDpxDrawerState = useSelector((state) => state.dataPointSlc.value.dpxListDrawerState);
    const selectorDataPointXrefId = useSelector((state) => state.dataPointXrefSlc.value.id);
    const selectorDataPointXrefMcode = useSelector((state) => state.dataPointXrefSlc.value.mcode);
    const selectorDataPointXrefName = useSelector((state) => state.dataPointXrefSlc.value.name);
    const selectorDataPointXrefDescription = useSelector((state) => state.dataPointXrefSlc.value.description);
    const displayId = useSelector((state) => state.dataPointSlc.value.id);
    const displayName = useSelector((state) => state.dataPointSlc.value.name);

    // ********************** END STORE ********************************


    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    // ****************** END REGISTER ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchDataPointXrefList = () =>
        getDataPointXrefByDataPointId(selectorDataPointId)
            .then(data => {
                console.log("this as my response");
                console.log(data);
                setDataPointXrefs(data);
            });


    useEffect(() => {
        fetchDataPointXrefList();
    }, [ useSelector((state) => state.dataPointSlc.value.dpxListDrawerState)===true]);

    // ****************** END FETCH ****************************


    const renderDataPointXrefs = dataPointXrefs => {
        if (dataPointXrefs.length <= 0) {
            return "No Data";
        }}



    const removeDataPointXref = () => {
        deleteDataPointXref(selectorDataPointXrefId).then(() => {
            setDeleteOpen(false);
            dispatchData(changeDataPoint({dpGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleMousedRow = (dataPoints) => {

        console.log(' data from clicked row');
        console.log(dataPoints);
        dispatchData(changeDataPoint({id: dataPoints.id,
            mcode: dataPoints.mcode, name: dataPoints.name,
            description: dataPoints.description,status:dataPoints.status, dataType: dataPoints.dataType,
            piiClassification: dataPoints.piiClassification, allowMany: dataPoints.allowMany}));
    };
    function CrudMenu() {

        const [anchorEl, setAnchorEl] = React.useState(null);

        const isMenuOpen = Boolean(anchorEl);

        const handleCrudMenuOpen = (event) => {
            setAnchorEl(event.currentTarget);
        };

        function handleMenuClose()  {
            setAnchorEl(null);

        };

        const handleEdit = () => {
            dispatchData(changeDataPoint({dpDrawerState: true,
                dpDrawerMode: "Edit"}));
        };

        const crudId = 'primary-search-account-menu';

        const renderMenu = (
            <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                id={crudId}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={isMenuOpen}
                onClose={handleMenuClose}
            >
                <MenuItem
                    onClick={handleEdit}
                >
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Edit</ListItemText>
                </MenuItem>
                <MenuItem onClick={removeDataPointXref}>
                    <ListItemIcon>
                        <DeleteOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                </MenuItem>
            </Menu>
        );
        return (
            <div>
                <IconButton
                    size="large"
                    edge="end"
                    aria-label="account of current user"
                    aria-controls={crudId}
                    aria-haspopup="true"
                    onClick={handleCrudMenuOpen}
                    color="inherit"
                >
                    <MoreVertIcon  color="primary" fontSize="small"/>
                </IconButton>
                {renderMenu}
            </div>
        );
    }

    // ****************** END CRUD ***********************************

    function closeDataPointXrefListDrawer() {
        dispatchData(changeDataPoint({dpxListId: 0, dpxListDrawerState: false}));
    };


    // ****************** BEGIN DRILLDOWN ****************************


    // ****************** END DRILLDOWN ****************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{pl: 1,
                    flexGrow: 1}}>
                    <Tooltip title={"Add Attribute"}>
                        <AddCircleOutlineIcon
                            sx={{mr: 3, mb: .5, verticalAlign: 'bottom'}}
                            fontSize="medium" color={'primary'}
                            // onClick={() => handleAdd()}
                        />
                    </Tooltip>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchDataPointXrefs => [

        {
            field: "more",
            // renderHeader: () => (
            // <AddCircleOutlineIcon  fontSize="medium" color={'inherit'} onClick={() => setShowDrawer(!showDrawer)}/>
            // ),
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: hideActions,
            renderCell: (dataPoints) => {
                return (
                    <div onMouseEnter = {() => handleMousedRow(dataPoints.row)}>
                        <CrudMenu/>
                    </div>
                );
            }
        },
{    field: 'id',
    headerName: 'ID',
    description: 'This column has a value getter and is not sortable.',
    sortable: true,
    width: 100,
},

{
    field: 'attributeName',
        headerName: 'Attribute',
    description: 'This column has a value getter and is not sortable.',
    sortable: true,
    // editable: true,
    width: 300,
},
{
    field: 'attributeId',
        headerName: 'Attribute ID',
    description: 'This column has a value getter and is not sortable.',
    sortable: true,
    // editable: true,
    width: 100,
},
{
    field: 'category',
        headerName: 'Category',
    description: 'This column has a value getter and is not sortable.',
    sortable: true,
    // editable: true,
    width: 200,
},

    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 800 },
                }}
                anchor='right'
                // open={true}
                open={selectorDpxDrawerState}
                initialState={{open: false}}
                onClose={closeDataPointXrefListDrawer}
            >
                <Box  style={{cursor:'pointer'}}  sx= {{pl: 2}}>
                <h1 onClick={() => closeDataPointXrefListDrawer()} sx={{ pl: 3}}>Data Point Attributes</h1>
                    <Stack direction="row" spacing={1}>
                        <Typography component="span">id:</Typography>
                        <Typography component="span" fontWeight="bold">{displayId}</Typography>
                        <Box sx={{ ml: 6 }} /> {/* Adds extra spacing before 'name:' */}
                        <Typography component="span">name:</Typography>
                        <Typography component="span" fontWeight="bold">{displayName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"DataPointXrefs"}
                    rows={dataPointXrefs}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(fetchDataPointXrefList)}
                    density={"compact"}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    rowKey={dataPointXref => dataPointXref.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
